import React from 'react';
import Header from "../../components/header/Header";
import availability from '../../props/icons/availability.svg';
import speed from '../../props/icons/speed.svg';
import trust from '../../props/icons/trust.svg';
import WebFooter from '../../components/webFooter/WebFooter';
import mail from '../../props/icons/mail-lg.svg';
import phone from '../../props/icons/telephone.svg';
import arrow from '../../props/icons/kap-arrow.svg';
import { Link } from 'react-router-dom'
import "./contact.scss"

function Contact() {
    return (
        <div className='Contact'>
                <Header />
           <div className='Contact__body'>
            <div  className='Contact__body__top'>
                <h3>Need  help?</h3>
                <p>Efficient customer service to ensure the quality of our service.</p>
            </div>
            <div  className='Contact__body__mid'>
                <div className='Contact__body__mid__item'>
                    <img src={speed} alt="icon" />
                    <p className='topText'>Speed</p>
                    <p  className='btmText'>Fast as Lightning, we’ll answer you within a day</p>
                </div>
                <div className='Contact__body__mid__item mob-hide'>
                <img src={trust} alt="icon" />
                    <p className='topText'>Trust</p>
                    <p  className='btmText'>We are committed to finding you the ideal swapper</p>
                </div>
                <div className='Contact__body__mid__item mob-hide'>
                <img src={availability} alt="icon" />
                    <p className='topText'>Availabilty</p>
                    <p  className='btmText'>We are available 24/7</p>
                </div>
            </div>
            <div  className='Contact__body__bottom'>
                <div className='main'>
                    <img src={mail} alt="" className='main__img'/>
                    <div >
                        <p className='topText'>Let’s chat by email</p>
                        <p className='midText'>
                        For general inquiries, partnerhip enquiries or media enquiries, send an email and we will be in touch as soon as possible.
                        </p>
                       <a href='mailto:kapitify@gmail.com'> <p className='linkText'><img src={arrow} alt="icon" className="arrow" /> Send an email</p></a>
                    </div>
                </div>

                <div className='main'>
                    <img src={phone} alt="" className='main__img'/>
                    <div >
                        <p className='topText'>Customer Support</p>
                        <p className='midText'>
                        Have questions, complaints or feature requests? Click to open a live chat and speak with one of our agents.
                        </p>
                       <a href='/contact'> <p className='linkText'><img src={arrow} alt="icon" className="arrow" />Open live chat</p></a>
                    </div>
                </div>

                <div className="join"> 
                    <p className='top'>Start swapping with kapitify</p>
                    <p className='bottom'>Create a free account in less than 5 minutes and start swapping!.</p>
                    <Link to="/waitlist"> <button>Sign up for free</button></Link>
                </div>
            </div>
           </div>
           <WebFooter/>
        </div>
    )
}
export default Contact